import styled from 'styled-components';

export const LabelFilter = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

export const LabelFilterButton = styled.button`
  background: transparent;
  border: 0;
  cursor: pointer;
  line-height: 1.5;
  margin-top: 8px;
  padding: 0;
  text-align: left;
`;
